import { inject, Injectable, NgZone } from '@angular/core'

import { Observable } from 'rxjs'
import { io, Socket } from 'socket.io-client'

import { ChatEventType } from '@yoshu-lib/models/chat-event.model'

import { isJSONString } from '@yoshu-lib/utils/is-json-string'

import { ENVIRONMENT } from '../tokens/environment.token'

@Injectable({ providedIn: 'root' })
export class SocketService {
  private readonly env = inject(ENVIRONMENT)

  socket?: Socket

  private ngZone = inject(NgZone)

  init(token: string) {
    if (this.socket && this.socket.connected) {
      return
    }

    this.socket = io(this.env.socketUrl, {
      auth: { token }
    })

    this.socket.on(ChatEventType.RefreshChatRooms, () => {
      this.socket?.emit(ChatEventType.JoinChatRooms)
    })
  }

  listen<T>(event: string): Observable<T> {
    if (!this.socket) throw new Error('Socket not initialized')

    return new Observable((observer) => {
      this.socket!.on(event, (data: T) => {
        const processedData: T = isJSONString(data) ? JSON.parse(data) : data
        this.ngZone.run(() => observer.next(processedData))
      })
    })
  }

  emit(event: string, data?: unknown) {
    if (!this.socket) throw new Error('Socket not initialized')
    this.socket.emit(event, data)
  }

  disconnect() {
    this.socket?.disconnect()
  }
}
